import React from "react";
import { Search, SlidersHorizontal, X } from "lucide-react";
import { cn } from "../../lib/utils";

const FilterBar = ({
  searchValue = "",
  onSearchChange,
  searchPlaceholder = "ابحث...",
  showSearch = true,
  filters = null,
  actions = null,
  onClear = null,
  className = "",
}) => (
  <div
    className={cn(
      "rounded-xl border border-neutral-200 bg-white p-3 shadow-sm dark:border-neutral-800 dark:bg-neutral-900",
      className,
    )}
  >
    <div className="flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between">
      {showSearch && (
        <div className="relative min-w-0 flex-1 lg:max-w-md">
          <Search
            className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-neutral-400"
            aria-hidden="true"
          />
          <input
            value={searchValue}
            onChange={(event) => onSearchChange?.(event.target.value)}
            placeholder={searchPlaceholder}
            aria-label={searchPlaceholder}
            className="h-10 w-full rounded-lg border border-neutral-200 bg-neutral-50 pe-10 ps-9 text-sm text-neutral-900 outline-none transition focus:border-primary-500 focus:bg-white focus:ring-2 focus:ring-primary-500/20 dark:border-neutral-700 dark:bg-neutral-950 dark:text-neutral-100 dark:focus:bg-neutral-900"
          />
          {searchValue && onClear && (
            <button
              type="button"
              onClick={onClear}
              className="absolute left-2 top-1/2 inline-flex h-7 w-7 -translate-y-1/2 items-center justify-center rounded-md text-neutral-400 hover:bg-neutral-100 hover:text-neutral-700 focus:outline-none focus:ring-2 focus:ring-primary-500 dark:hover:bg-neutral-800 dark:hover:text-neutral-200"
              aria-label="مسح البحث"
            >
              <X size={14} />
            </button>
          )}
        </div>
      )}
      <div className="flex flex-1 flex-wrap items-center gap-2 lg:justify-end">
        {filters && (
          <div
            className="flex flex-wrap items-center gap-2 text-sm"
            aria-label="الفلاتر"
          >
            <SlidersHorizontal
              size={16}
              className="text-neutral-400"
              aria-hidden="true"
            />
            {filters}
          </div>
        )}
        {actions && (
          <div className="flex flex-wrap items-center gap-2">{actions}</div>
        )}
      </div>
    </div>
  </div>
);

export default FilterBar;
